import React from 'react';
import styled from 'styled-components';
import { SectionParent, H2, H1 } from '../../StyledComponents';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Quality from '../../../assets/v2/Health/Quality.svg';

const Section = styled(SectionParent)`
  background: #ffffff;
  padding-top: 1rem !important;
  padding-bottom: 2rem !important;
  @media (max-width: 520px) {
    padding-top: 1rem !important;
    padding-bottom: 0rem !important;
  }
`;
const Grid = styled.div`
  display: grid;
  padding-bottom: 3rem;
  padding-top: 2rem;
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 700px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
const GridItem = styled.div`
  justify-self: center;
  max-width: 80%;
  align-self: center;
  grid-column: span 2;
  @media (max-width: 768px) {
    margin-right: 0rem;
  }
  @media (max-width: 700px) {
    grid-column: span 3;
    display: grid;
    margin-right: 0rem;
    justify-items: center;
  }
`;
const SectionContent = styled(H2)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  width: 100%;
  color: #626679;
  padding-top: 0.5rem;
  text-align: justify;
  img {
    margin-top: 1rem;
  }
  @media (max-width: 700px) {
    padding-left: 0;
    text-align: justify;
    width: 90%;
  }
  @media (max-width: 520px) {
    width: 120%;
    text-align: center;
  }
`;
const SectionTitle = styled(H1)`
  @media (min-width: 1440px) {
    font-size: 28px !important;
  }
  font-weight: bold;
  font-family: 'Nunito Sans', sans-serif;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151828;
`;

const TargetImage = styled(LazyLoadImage)`
  width: 100%;
  margin-top: 2rem;
  justify-self: center;
  @media (max-width: 768px) {
    width: 90%;
    margin-top: 0;
  }
`;
const ImgWrapper = styled.div`
  display: grid;
  align-items: center;
  @media (max-width: 768px) {
    grid-column: span 2;
  }
  @media (max-width: 700px) {
    grid-column: span 3;
  }
  @media (max-width: 520px) {
    padding-bottom: 2rem;
  }
`;
export default () => (
  <Section>
    <Grid>
      <ImgWrapper>
        <TargetImage src={Quality} />
      </ImgWrapper>

      <GridItem>
        <SectionTitle>Speed and Product Quality Matter</SectionTitle>

        <SectionContent>
          Healthcare innovators compete on speed-to-market. You have to move
          fast and provide regulators with proof of quality management at every
          stage of the product life cycle.
          <br />
          <br />
          Esper can help you transform your Android health device idea to
          production-ready deployment in a matter of days. We handle hardware
          selection, validation, and deployment, so you can focus on a
          bulletproof regulatory strategy.
        </SectionContent>
      </GridItem>
    </Grid>
  </Section>
);
